const LoadingContainer = ({ isLoading, children }) => {
  return (
    <div className={`loading-wrapper${isLoading ? ' loading-wrapper--loading' : ''}`}>
      {isLoading && (
        <div className="loading-overlay">
          <span>Cargando...</span>
        </div>
      )}
      {children}
    </div>
  );
};

export default LoadingContainer;
